import { Dropdown, Button, Space } from 'antd';
import { IconGlobe, IconChevronDown } from './icons';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, changeLanguage } from '../../core/i18n';
import { getAccessToken } from '../../utils/auth';
import { updatePreferredLanguage } from '../../services/api-client';

/**
 * Language Switcher component for changing the application language.
 */
const LanguageSwitcher = ({ size = 'middle', showLabel = true }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const currentLang = SUPPORTED_LANGUAGES.find(lang => lang.code === currentLanguage)
    || SUPPORTED_LANGUAGES[0];

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    // Force a re-render of the entire app by triggering language change event
    window.dispatchEvent(new Event('languagechange'));
    // Persist the choice server-side so notifications and server-resolved
    // content follow it. Only when authenticated (the switcher also renders
    // on the login screen). Best-effort: the in-app language already changed.
    if (getAccessToken()) {
      updatePreferredLanguage(langCode).catch(() => {});
    }
  };

  const items = SUPPORTED_LANGUAGES.map(lang => ({
    key: lang.code,
    label: (
      <Space>
        <span>{lang.nativeName}</span>
        {lang.code === currentLanguage && <span>✓</span>}
      </Space>
    ),
    onClick: () => handleLanguageChange(lang.code),
  }));

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      placement="bottomRight"
    >
      <Button type="text" size={size}>
        <Space>
          <IconGlobe />
          {showLabel && <span>{currentLang.nativeName}</span>}
          <IconChevronDown style={{ fontSize: 10 }} />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;

